import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { pdfDefaultOptions } from "ngx-extended-pdf-viewer";

// Suppress PDF.js font warnings globally
pdfDefaultOptions.verbosity = 0; // 0 = errors only, 1 = warnings, 5 = all

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
